import React, { useEffect, useState } from 'react';
import { Row, Col, Card, CardBody, Spinner } from "reactstrap";
import { ref, get, onValue } from "firebase/database";
import { db } from '../../../../firebase';
import { errorToast } from '../../../common/toast';

const UserDashboard = () => {
  const [totalNumberOfForms, setTotalNumberOfForms] = useState(0);
  const [submittedForms, setSubmittedForms] = useState(0);
  const userData = JSON.parse(localStorage.getItem('user') || '{}');

  const [packagesLoading, setPackagesLoading] = useState(false);
  const [usersLoading, setUsersLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      setPackagesLoading(true);
      // setUsersLoading(true);

      try {
        if (!userData?.plan?.value) {
          throw new Error("Package value not found.");
        }

        const packageRef = ref(db, `packages/${userData.plan.value}`);
        const packageSnapshot = await get(packageRef);

        if (packageSnapshot.exists()) {
          const packageData = packageSnapshot.val();
          setTotalNumberOfForms(packageData?.noOfForms || 0);
        } else {
          errorToast("No package data found.");
        }
      } catch (error) {
        errorToast("Error fetching packages: " + error.message);
      } finally {
        setPackagesLoading(false);
      }

      try {
        const formsRef = ref(db, `userForms/${userData?.uid}`);
        onValue(formsRef, (snapshot) => {
          const formsData = snapshot.val();

          if (formsData) {
            const paraKeys = Object.keys(formsData).filter((key) => key.startsWith('para'));
            setSubmittedForms(paraKeys.length);
            setUsersLoading(false);
          } else {
            setSubmittedForms(0);
            setUsersLoading(false);
          }
        });
      } catch (error) {
        errorToast("Error fetching user forms: ", error);
      }
      // finally {
      //   setUsersLoading(false);
      // }
    };

    fetchData();
  }, []);

  const userDashboardData = [
    { title: "Total Number Of Forms", value: totalNumberOfForms, bgColor: "bg-primary", icon: "bi bi-person", isLoading: packagesLoading },
    { title: "Submitted Forms", value: submittedForms, bgColor: "bg-success", icon: "bi bi-check-circle", isLoading: usersLoading },
    { title: "End Date", value: userData?.endDate || "N/A", bgColor: "bg-danger", icon: "bi bi-calendar" },
  ];

  return (
    <div className="container mt-4">
      <Row>
        {userDashboardData.map((data, index) => (
          <Col lg="3" md="4" sm="12" className="mb-4" key={index}>
            <Card className={`${data.bgColor} text-white`}>
              <CardBody className="d-flex align-items-center justify-content-between">
                <div>
                  {data?.isLoading ? <Spinner size={"sm"} /> : <h5 className="mb-0">{data.value}</h5>}
                  <p className="mb-0">{data.title}</p>
                </div>
                <div>
                  <i className={`${data.icon} fs-3`}></i>
                </div>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default UserDashboard;
